<template>
    <div>
        <div class="speaker-header">
            <div class="container">
                <div class="row">
                    <div class="header-flex">
                        <div class="col-lg-6 mx-auto order2">
                            <h2 class="section-title">
                                Webinar Speakers
                            </h2>
                        </div><!-- col end-->
                        <div class="col-lg-6 order1">
                            <div class="speaker-header-icon">
                                <img src="/images/speakers/webinar-vector.png">
                            </div>
                        </div>
                    </div>
                </div><!-- row end-->
            </div>
            <div class="header-icons">
                <img src="/images/speakers/top-left.png">
                <img src="/images/speakers/top-right.png">
                <img src="/images/speakers/top-center.png">
                <img src="/images/speakers/bottom-left.png">
                <img src="/images/speakers/bottom-right.png">
            </div>
        </div>
        <div class="container-speakers">
            <div class="row">
                <div class="col-lg-3 col-md-6" v-for="speaker in data">
                    <div class="ts-speaker">
                        <div class="speaker-img">

                            <img class="img-fluid" :src="speaker.image" v-if="speaker.image">
                            <img class="img-fluid" src="images/user_avatar.png" v-else>

                            <a href="javascript:;" class="view-speaker ts-image-popup" :data-key="speaker.speaker_enc_id" @click="SpeakerModal($event)">
                                <i class="fas fa-plus"></i>
                            </a>
                        </div>
                        <div class="ts-speaker-info">
                            <h3 class="ts-title"><a href="#">{{speaker.fullname}}</a></h3>
                            <p>{{speaker.designation}}</p>
                        </div>
                    </div>
                </div>
                <SpeakerModal></SpeakerModal>
            </div>
        </div>
    </div>

</template>

<script>
    import SpeakerModal from  '../../components/SpeakerModal';
    import axios from "axios";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components:{
            SpeakerModal
        },
        data: function(){
            return{
                data:[],
                speaker_data:[]
            }
        },

        mounted(){
            this.getDetail();
        },
        methods:{
            SpeakerModal(event){
                var element = event.currentTarget;
                var data_key = element.getAttribute('data-key');
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/webinars/speaker-detail`, {speaker_enc_id:data_key}, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.speaker_data = response['data']['response']['data'];
                        // console.log(t.speakerData);
                        $('#speaker').modal('show');
                        t.$children[0].getSpeakerData();
                    }
                });
            },
            getDetail() {
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/webinars/speakers`, '', {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.data = response['data']['response']['data'];
                    }
                });
            },
            speakerData(){
                return this.speaker_data;
            }
        },
    }
</script>
